/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { JackpotFormats } from './JackpotFormats';
import {
    JackpotFormatsFromJSON,
    JackpotFormatsFromJSONTyped,
    JackpotFormatsToJSON,
} from './JackpotFormats';

/**
 * 
 * @export
 * @interface FastPlayJackpot
 */
export interface FastPlayJackpot {
    /**
     * 
     * @type {JackpotFormats}
     * @memberof FastPlayJackpot
     */
    formattedCashJackpot?: JackpotFormats | null;
    /**
     * 
     * @type {JackpotFormats}
     * @memberof FastPlayJackpot
     */
    formattedJackpot: JackpotFormats;
    /**
     * 
     * @type {Date}
     * @memberof FastPlayJackpot
     */
    asOf: Date;
    /**
     * 
     * @type {number}
     * @memberof FastPlayJackpot
     */
    jackpotCashAmountInCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FastPlayJackpot
     */
    jackpotAmountInCents: number;
    /**
     * 
     * @type {string}
     * @memberof FastPlayJackpot
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof FastPlayJackpot
     */
    jackpotGroupId: string;
    /**
     * 
     * @type {string}
     * @memberof FastPlayJackpot
     */
    id: string;
}

/**
 * Check if a given object implements the FastPlayJackpot interface.
 */
export function instanceOfFastPlayJackpot(value: object): value is FastPlayJackpot {
    if (!('formattedJackpot' in value) || value['formattedJackpot'] === undefined) return false;
    if (!('asOf' in value) || value['asOf'] === undefined) return false;
    if (!('jackpotAmountInCents' in value) || value['jackpotAmountInCents'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('jackpotGroupId' in value) || value['jackpotGroupId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function FastPlayJackpotFromJSON(json: any): FastPlayJackpot {
    return FastPlayJackpotFromJSONTyped(json, false);
}

export function FastPlayJackpotFromJSONTyped(json: any, ignoreDiscriminator: boolean): FastPlayJackpot {
    if (json == null) {
        return json;
    }
    return {
        
        'formattedCashJackpot': json['formattedCashJackpot'] == null ? undefined : JackpotFormatsFromJSON(json['formattedCashJackpot']),
        'formattedJackpot': JackpotFormatsFromJSON(json['formattedJackpot']),
        'asOf': (new Date(json['asOf'])),
        'jackpotCashAmountInCents': json['jackpotCashAmountInCents'] == null ? undefined : json['jackpotCashAmountInCents'],
        'jackpotAmountInCents': json['jackpotAmountInCents'],
        'customerId': json['customerId'],
        'jackpotGroupId': json['jackpotGroupId'],
        'id': json['id'],
    };
}

export function FastPlayJackpotToJSON(value?: FastPlayJackpot | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'formattedCashJackpot': JackpotFormatsToJSON(value['formattedCashJackpot']),
        'formattedJackpot': JackpotFormatsToJSON(value['formattedJackpot']),
        'asOf': ((value['asOf']).toISOString()),
        'jackpotCashAmountInCents': value['jackpotCashAmountInCents'],
        'jackpotAmountInCents': value['jackpotAmountInCents'],
        'customerId': value['customerId'],
        'jackpotGroupId': value['jackpotGroupId'],
        'id': value['id'],
    };
}

